import { onCleanup } from 'solid-js'
import type { Object3D } from 'three'
import disposeRecursive from '../../lib/three/fn/disposeRecursive'
import type { HasDisposeOrTraverse, Nullable } from '../../typescript'

/**
 * Disposes a disposable on cleanup
 */
export function onCleanupRemoveAndDispose(disposable: Nullable<HasDisposeOrTraverse>) {
  onCleanup(() => {
    if (disposable) {
      ;(disposable as Object3D).removeFromParent?.()
      disposeRecursive(disposable)
    }
  })
}
